"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddFavoriteGame = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useAddFavoriteGame = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        keysUpdate: [keys_1.GET_FAVORITE_GAMES],
        path: keys_1.ADD_FAVORITE_GAME,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        addFavoriteGame: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useAddFavoriteGame = useAddFavoriteGame;
